/**
 * Registers the slice's translations into the shared "tools" namespace.
 *
 * Feature slices add their own keys with addResourceBundle rather than editing
 * the shared locale JSON (see lib/i18n/i18n.ts). Importing this module for its
 * side effect (from index.tsx / the action-plan cell) is enough.
 */
import i18n from "@/lib/i18n/i18n";

import { toolsEn } from "./locales/en";
import { toolsFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { tools: toolsFr }, true, true);
i18n.addResourceBundle("en", "translation", { tools: toolsEn }, true, true);
